/*
 *
 * Returns an interpolated string for CSS lookups
 * Example use:
 * getTestSelector(IrisDropdownTestHook.container)
 * would return: [data-cy="irisv-dropdown__container"]
*/
export const getTestSelector = (hook: string) => `[data-cy="${hook}"]`;
